import api from '../config/axios';
import {
  OCRAdaptation,
  OCRAdaptationFormData,
  OCRAdaptationTestRequest,
  OCRAdaptationTestResult,
} from '../types/ocrAdaptation';

class OCRAdaptationService {
  async fetchAdaptations(params: { search?: string; active?: boolean } = {}): Promise<OCRAdaptation[]> {
    const queryParams = new URLSearchParams();
    if (params.search) queryParams.append('search', params.search);
    if (params.active !== undefined) queryParams.append('active', params.active.toString());

    const query = queryParams.toString();
    const response = await api.get(`/ocr-adaptations${query ? `?${query}` : ''}`);
    return response.data.adaptations;
  }

  async fetchDefaultInstructionSet(): Promise<string> {
    const response = await api.get('/ocr-adaptations/default-instruction-set');
    return response.data.instructionSet;
  }

  async testAdaptation(data: OCRAdaptationTestRequest): Promise<OCRAdaptationTestResult> {
    const formData = new FormData();
    formData.append('pdf', data.file);
    if (data.instructionSet) formData.append('instructionSet', data.instructionSet);
    if (data.vendorName) formData.append('vendorName', data.vendorName);

    const response = await api.post('/ocr-adaptations/test', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      timeout: 120000,
    });

    return response.data;
  }

  async createAdaptation(data: OCRAdaptationFormData): Promise<OCRAdaptation> {
    const response = await api.post('/ocr-adaptations', data);
    return response.data.adaptation;
  }

  async updateAdaptation(id: number, data: OCRAdaptationFormData): Promise<OCRAdaptation> {
    const response = await api.put(`/ocr-adaptations/${id}`, data);
    return response.data.adaptation;
  }

  async toggleAdaptation(id: number): Promise<OCRAdaptation> {
    const response = await api.patch(`/ocr-adaptations/${id}/toggle`);
    return response.data.adaptation;
  }

  async deleteAdaptation(id: number): Promise<number> {
    await api.delete(`/ocr-adaptations/${id}`);
    return id;
  }
}

const ocrAdaptationService = new OCRAdaptationService();
export default ocrAdaptationService;
